import { Component, Input, OnInit } from "@angular/core";
import { UntypedFormControl } from "@angular/forms";
import { months, monthsNumeric } from "../../../../consts";
import { MonthModel } from "../../../../shared/components/table/month.model";
import { ActualSelected } from "../../../../shared/utils";
import { ResumeService } from "../../../resume/resume.service";
import { SummaryResultModel } from "../../../resume/summary-result.model";

@Component({
    selector: 'report-total',
    templateUrl: './report-total.component.html',
    styleUrls: ['../../accounting-tabs.component.scss'],
    standalone: false
})

export class ReportTotalComponent implements OnInit {
  @Input()
  showGlobal: boolean = false;

  monthControl = new UntypedFormControl(monthsNumeric);
  monthsSelected: string[];
  monthList: MonthModel[] = [];
  allMonthsSelected = false;

  resumeloading = false;
  summaryResult: SummaryResultModel;


  constructor(
    private resumeService: ResumeService,
  ) {
  }

  ngOnInit() {
    this.setMonths();
    this.getData();
  }

  getData() {
    ActualSelected.global = this.showGlobal ? "1" : "0";

    this.resumeService.getResumeResults({ isGlobal: this.showGlobal }).then(response => {
      this.summaryResult = response.result;
      this.resumeloading = true;
    });
  }

  getPositivePercentage(num1, num2) {
    const ratio = num1 / num2;
    return Math.abs(ratio); // Usa Math.abs para garantizar un valor positivo
  }

  setMonths() {
    if (this.monthList.length === 0) {
      let i = 1;
      months.forEach(element => {
        const newMonth = new MonthModel();
        newMonth.name = element;
        newMonth.selected = true;
        newMonth.number = i.toString();
        this.monthList.push(newMonth);
        i += 1;
      });
      this.allMonthsSelected = true;
      this.monthsSelected = monthsNumeric;
      ActualSelected.monthSelectedResume = monthsNumeric;
    }
  }

  onChangeMonth(event) {
    this.monthsSelected = event.value;
    ActualSelected.monthSelectedResume = event.value;
    this.allMonthsSelected = false;

    this.monthList.forEach(element => element.selected = false);
    event.value.forEach(element => {
      this.monthList.find(f => f.number == element).selected = true;
    });

    this.getData();
  }

  onSelectAll(event) {
    if (event.checked) {
      this.allMonthsSelected = true;
      this.monthsSelected = monthsNumeric;
      ActualSelected.monthSelectedResume = monthsNumeric;
      this.monthControl.setValue(monthsNumeric, { emitEvent: false });
      this.monthList.forEach(element => element.selected = true);
    } else {
      this.allMonthsSelected = false;
      this.monthsSelected = [];
      ActualSelected.monthSelectedResume = [];
      this.monthControl.setValue([], { emitEvent: false });
      this.monthList.forEach(element => element.selected = false);
    }
    this.getData();
  }

  getSelectedMonthsNames(): string {
    const selectedNames = this.monthsSelected.map(index => this.monthList[parseInt(index) - 1].name);
    return selectedNames.join(', ');
  }
  public trackByIndex(i: number) { return i; }

}
